import React from 'react';
import { motion } from 'framer-motion';

const BrandFooter = ({ variant = 'light' }) => {
  const textColor = variant === 'dark' ? 'text-white' : 'text-gray-600';
  const licenseColor = variant === 'dark' ? 'text-gray-300' : 'text-gray-500';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="text-center py-8"
    >
      <div className="mb-4">
        <p className={`text-sm font-medium ${textColor} mb-3`}>
          Powered by
        </p>
        
        {/* Brand Logos Container */}
        <div className="flex items-center justify-center space-x-6">
          {/* Burbank Insurance Logo */}
          <div className="flex items-center">
            <img 
              src="https://app1.sharemyimage.com/2025/05/19/burbank-insurance-services-in-california-logo.png"
              alt="Burbank Insurance Services"
              className="h-12 object-contain"
            />
          </div>

          {/* X Symbol */}
          <div className={`text-2xl font-light ${textColor} mx-3`}>×</div>

          {/* Ethos Logo */}
          <div className="flex items-center">
            <img 
              src="https://app1.sharemyimage.com/2025/08/18/ethos-logo_RGB_cypress.jpg"
              alt="Ethos Life Insurance"
              className="h-8 object-contain"
            />
          </div>
        </div>
      </div>

      {/* License Information */}
      <div className={`text-xs ${licenseColor}`}>
        <p>Burbank Insurance Services</p>
        <p>CA License #6013543</p>
      </div>
    </motion.div>
  );
};

export default BrandFooter;